import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { isClubless, NO_CLUB_ROUTE } from './postLoginRoute'

/**
 * "Solo si estás asignado a un club deberías poder avanzar o hacer cualquier
 * cosa" (mg, 2026-09-09). Guard que manda a `/sin-club` a toda cuenta de
 * jugador que no pertenece a ningún club — que desde esa fecha es el estado
 * NORMAL de cualquiera que se registra solo, porque el alta pública ya no lo
 * mete en el club default (ver `backend/app/services/default_club.py`).
 *
 * Envuelve las dos superficies del jugador, `/` (el puente al vr-app) y
 * `/data`. NO envuelve `/sin-club` (sería un loop), ni `/club` y `/admin`
 * (ahí no llega un jugador suelto: `isClubless` ya exceptúa a staff y
 * superadmins), ni `/tablet` (la credencial es el kit de un club, así que
 * quien entra por ahí tiene club por construcción), ni `/legal/*` ni
 * `/set-pin`.
 *
 * Va SIEMPRE por dentro de `RequireAuth`: sin usuario hidratado no hay nada
 * que decidir, y `RequireAuth` es el que sabe rebotar a `/login`.
 */
export function RequireClub({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  if (user && isClubless(user)) {
    return <Navigate to={NO_CLUB_ROUTE} replace />
  }
  return <>{children}</>
}
